// extracted by mini-css-extract-plugin
export default {"draw-result":"DrawResult_draw-result_dEIvzBuorltaDveHup5A","symbol":"DrawResult_symbol_GAVhuYcyNagmJTC3Sb1_"};